import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useEntityStore } from '../../common/composables/entityStore';
import type { Package } from '../domain/package';

export const usePackageStore = defineStore('packages', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } = useEntityStore<Package>(
    {
      eventName: 'package-changed',
      getEntityId(entity) {
        return entity.id;
      },
      updateEntity(dest, src) {
        dest.number = src.number;
        dest.externalNumber = src.externalNumber;
        dest.status = src.status;
        dest.statusValidFrom = src.statusValidFrom;
        dest.statusValidTo = src.statusValidTo;
        dest.packageTypeId = src.packageTypeId;
        dest.piecesCount = src.piecesCount;
        dest.layers = src.layers;
        dest.piecesPerLayer = src.piecesPerLayer;
        dest.spacerHeight = src.spacerHeight;
        dest.composition = src.composition;
        dest.packageStorageAreaId = src.packageStorageAreaId;
        dest.stackLevel = src.stackLevel;
        dest.occupiedStoragePlaceIds = src.occupiedStoragePlaceIds;
        dest.nominalWeight = src.nominalWeight;
        dest.weight = src.weight;
        dest.nominalHeight = src.nominalHeight;
        dest.height = src.height;
        dest.nominalWidth = src.nominalWidth;
        dest.width = src.width;
        dest.nominalLength = src.nominalLength;
        dest.length = src.length;
        dest.nominalVolume = src.nominalVolume;
        dest.volume = src.volume;
        dest.nominalRunningMeters = src.nominalRunningMeters;
        dest.runningMeters = src.runningMeters;
        dest.longitude = src.longitude;
        dest.latitude = src.latitude;
        dest.rotation = src.rotation;
        dest.comment = src.comment;
        dest.contents = (src.contents ?? []).map((content) => ({
          ...content,
          codes: content.codes.map((code) => ({ ...code })),
        }));
        dest.timesMovedCount = src.timesMovedCount;
        dest.distanceTravelledMetres = src.distanceTravelledMetres;
        dest.timeCarriedSeconds = src.timeCarriedSeconds;
        dest.weightedDistanceTravelledMetres = src.weightedDistanceTravelledMetres;
        dest.createdAtUtc = src.createdAtUtc;
      },
      hasChanged(existing, incoming) {
        return JSON.stringify(existing) !== JSON.stringify(incoming);
      },
    },
  );

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    packages: computed(() => list.value),
    sortedByNumber: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => (a.number ?? '').localeCompare(b.number ?? '', undefined, { numeric: true }));
      return clone;
    }),
  };
});
